module.exports = __webpack_public_path__ + "img/Folded_Paper_Werk_Mobilyze_image_10.d4b33781.png";